import type {
  LeadFlowAnswerLabels,
  LeadFlowChoiceFieldName,
  LeadFlowDocument,
  LeadFlowStepItem,
} from "../types";

const CHOICE_FIELD_BY_QUESTION_TYPE: Partial<
  Record<LeadFlowStepItem["_type"], LeadFlowChoiceFieldName>
> = {
  leadFlowCareForQuestion: "careFor",
  leadFlowCareTypeQuestion: "careType",
  leadFlowUrgencyQuestion: "urgency",
};

type ChoiceOption = { label?: string | null; value?: string | null };

function getQuestionOptions(item: LeadFlowStepItem): ChoiceOption[] {
  return "options" in item && Array.isArray(item.options) ? item.options : [];
}

/**
 * Collects option labels for each choice question in the flow. Studio's
 * contract check keeps a field from being asked twice, so each field has one
 * question's labels.
 */
function getAnswerLabels(leadFlow: LeadFlowDocument): LeadFlowAnswerLabels {
  const answerLabels: LeadFlowAnswerLabels = {};

  for (const step of leadFlow.steps ?? []) {
    if (step._type !== "leadFlowStep") {
      continue;
    }

    for (const item of step.items ?? []) {
      const fieldName = CHOICE_FIELD_BY_QUESTION_TYPE[item._type];

      if (!fieldName) {
        continue;
      }

      const labels: Record<string, string> = {};
      for (const option of getQuestionOptions(item)) {
        if (option.value && option.label) {
          labels[option.value] = option.label;
        }
      }
      answerLabels[fieldName] = labels;
    }
  }

  return answerLabels;
}

export { getAnswerLabels };
